import { AnimationTriggerMetadata, trigger, state, style, transition, animate } from '@angular/animations';

export const ExpandCollapseAnimation: AnimationTriggerMetadata[] = [
  trigger('expandCollapse', [
    state('collapsed', style({ height: '0', overflow: 'hidden', opacity: '0' })),
    state('*, expanded', style({ height: '*', overflow: 'visible', opacity: '1' })),
    transition('void <=> false, collapsed <=> false, expanded <=> false', []),
    transition('collapsed => expanded', [animate('225ms cubic-bezier(0.0, 0.0, 0.2, 1)')]),
    transition('expanded => collapsed', [animate('225ms cubic-bezier(0.0, 0.0, 0.2, 1)')]),
  ]),
];

export const ExpandCollapseWidthAnimation: AnimationTriggerMetadata[] = [
  trigger('expandCollapseWidth', [
    state('collapsed', style({ width: '0', height: '40px', display: 'block', overflow: 'hidden', opacity: '0' })),
    state('*, expanded', style({ width: '*', height: '*', display: '*', overflow: 'visible', opacity: '1' })),
    transition('void <=> false, collapsed <=> false, expanded <=> false', []),
    transition('collapsed => expanded', [animate('225ms cubic-bezier(0.0, 0.0, 0.2, 1)')]),
    transition('expanded => collapsed', [animate('225ms cubic-bezier(0.0, 0.0, 0.2, 1)')]),
  ]),
];

export const SlideInAnimation: AnimationTriggerMetadata[] = [
  trigger('slideIn', [
    state('collapsed', style({ transform: 'translate(-100%, 0)' })),
    state('*, expanded', style({ transform: 'translate(0, 0)' })),
    transition('void <=> false, collapsed <=> false, expanded <=> false', []),
    transition('collapsed => expanded', [animate('225ms cubic-bezier(0.0, 0.0, 0.2, 1)')]),
    transition('expanded => collapsed', [animate('225ms cubic-bezier(0.0, 0.0, 0.2, 1)')]),
  ]),
];
